<!--Footer 1 ( Available mostly throughout the Application)----------------------->
<div
	*ngIf="!hideFooter"
	fxFlex="100"
	fxLayout="row"
	class="footer-background"
	ngClass.gt-md="p-xxl"
	ngClass.md="p-t-xxl p-b-xxl p-l"
	ngClass.sm="p-l"
	ngClass.xs="p-s"
	id="footer"
	name="footer"
>
	<div
		fxLayout="column"
		fxLayoutAlign="center center"
		fxFlex="100%"
		fxLayoutAlign="center space-between"
	>
		<!--FIRST ROW STARTS-->
		<div
			fxFlex="100"
			fxLayout="row"
			fxLayout.sm="column"
			fxLayout.xs="column"
			fxLayoutAlign="space-between start"
			fxLayoutGap.sm="2%"
			fxLayoutGap.xs="5%"
		>
			<!--LOGO AND APP LINKS-------------------------------------------------------------------->
			<app-logo-app-links fxFlex.gt-sm="19%"></app-logo-app-links>

			<!--FIRST COLUMN-->
			<!--SECOND COLUMN-->

			<!--FUNDRAISER FOR---------------------------------------------------------------------->
			<app-fundraiser-for fxFlex.gt-sm="19%"></app-fundraiser-for>

			<!--PRODUCTS-------------------------------------------------------------------------------->
			<app-products fxFlex.gt-sm="19%"></app-products>

			<!--FEATURES-------------------------------------------------------------------------------->
			<app-features fxFlex.gt-sm="19%"></app-features>

			<!--SUPPORT-------------------------------------------------------------------------------->
			<app-support fxFlex.gt-sm="19%"></app-support>
		</div>

		<!--FIRST ROW ENDS-->

		<!--SECOND ROW STARTS------------------------------------------------------------------------------->

		<div
			fxFill
			fxLayout="column"
			fxLayout.sm="column"
			fxLayout.xs="column"
			fxFlex="100%"
			fxLayoutAlign="space-between"
			fxLayoutAlign.sm="space-between start"
			fxLayoutAlign.xs="space-between start"
		>
			<div fxlayout="row" fxlayoutAlign="space-between">
				<!--FIRST COLUMN-->

				<!--SECOND COLUMN-->
			</div>
			<div fxlayout="row" fxlayoutAlign="space-between end"></div>
			<app-copyright fxFlex.gt-md="70%" fxFlex.gt-sm="82%"></app-copyright>
		</div>

		<!--SECOND ROW ENDS------------------------------------------------------------------------------->
	</div>
</div>

<!--FOOTER 2 (Available during accessing USER menu dashboard)------------------------------------------------------------------------------------------------------------------->
<div
	*ngIf="this.hideFooter"
	fxFill
	fxLayout="row"
	fxLayoutAlign="space-between center"
	id="footer2"
	name="footer2"
	class="minimal-footer"
	fxFlex="100%"
>
	<div fxLayout="column" fxFlex="50%" fxLayoutAlign="center start">
		<div fxLayout="row" fxLayoutAlign="center center" >
			<app-language-chooser></app-language-chooser>
			<!-- Button to open Cookie Settings modal -->
			<a mat-button (click)="openCookieSettings()">
				<div fxLayoutAlign="start center">
					<span class="material-icons-outlined">
						cookie
					</span>
					<span fxHide.lt-sm="true" i18n="@@footer_label_cookieSettings"
						>&nbsp;Cookie Settings</span
					>
				</div>
			</a>
		</div>
	</div>

	<div fxLayout="column" fxFlex="50%" fxLayoutAlign="center end">
		<div
			fxLayout="row"
			fxFlex="100%"
			fxLayoutAlign="end center"
			fxLayoutGap="5%"
		>
			<label i18n="@@footer_label_poweredBy" class="footer-no-wrap"
				>Powered by:&nbsp;</label
			>
			<img
				fxFlex.lt-sm="60%"
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public"
			/>
		</div>
	</div>
</div>
